import React from 'react';
import { IconButton } from '@oneaudi/unified-web-components';

import styled from 'styled-components';
import type { IconNamesType } from '@oneaudi/unified-web-components/dist/cjs/components/icon/icon-names.generated';
import type { SocialMediaType } from '../../types/audi-footer-response.types';
import type { TrackingClickEvent } from '../../utils/tracking';
import { useTracking } from '../../utils/tracking';
import { TrackingContext } from '../../context';
import { breakpoints } from '../../utils/breakpoints';
import { responsiveStyles } from '../../utils/responsiveStyles';
import { SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150 } from '@oneaudi/unified-web-common';

interface SocialMediaProps {
  socialMedia: SocialMediaType[];
}

const iconNameMapping: { [key: string]: IconNamesType } = {
  twitter: 'x',
  line: 'line-me',
};
const RightAlignedButtonGroup = styled.div`
  flex-direction: row;
  display: flex;
  padding-bottom: ${SYS_SPACE_FIXED_150};
  gap: ${process.env.IS_LEGACY ? 0 : SYS_SPACE_FIXED_100};

  // custom css in order to align items in <ButtonGroup> right
  ${(): string =>
    responsiveStyles(
      {
        'justify-content': { xxs: 'flex-start', m: 'flex-end' },
      },
      breakpoints,
    )}
`;

const SocialMedia: React.FC<SocialMediaProps> = ({ socialMedia }) => {
  const trackingService = React.useContext(TrackingContext);
  const { sendClickEvent } = useTracking(trackingService);
  const sendButtonClickEvent = (
    label: string,
    url: string,
    variant: string,
    openin: string,
    position: string,
  ) => {
    const event: TrackingClickEvent = {
      linkLabel: label,
      linkUrl: url,
      elementName: variant,
      headline: label,
      OpenIn: openin,
      position,
    };

    sendClickEvent(event);
  };
  return (
    <RightAlignedButtonGroup>
      {socialMedia.map((socialMediaItem) => {
        const { Id, Link } = socialMediaItem;
        const { Text, Url, Target } = Link;
        return Url ? (
          <IconButton
            href={Url}
            className="icon-button"
            target={Target}
            onClick={() => {
              //@ts-expect-error Text is an optional argument
              sendButtonClickEvent(Text, Url, 'text link', Target, '');
            }}
            key={Id}
            size={process.env.IS_LEGACY ? 'md' : 'sm'}
            aria-label={Text || iconNameMapping[Id] || Id}
            variant={process.env.IS_LEGACY ? 'tertiary' : 'secondary'}
            icon={iconNameMapping[Id] || Id}
            rel="noopener noreferrer"
          />
        ) : null;
      })}
    </RightAlignedButtonGroup>
  );
};

export default SocialMedia;
